import React, { useEffect, useMemo, useState } from "react";
import { Modal, Input, Button, Space } from "antd";
import { MODAL } from "../../constants/layout";

interface JsonModalProps {
  title: string;
  visible: boolean;
  content: string;
  onCancel: () => void;
}

/**
 * JSON 内容展示模态框组件
 * @param props - 组件属性
 * @returns React 元素
 */
const JsonModal: React.FC<JsonModalProps> = ({
  title,
  visible,
  content,
  onCancel,
}) => {
  const [str, setStr] = useState("");
  useEffect(() => {
    setStr(content);
  }, [content]);
  const handleFormatToBase64 = () => {
    setStr(window.atob(str));
  };
  const isHidden = useMemo(() => title === "Request Header", [title]);
  return (
    <Modal
      title={
        <Space>
          <div>{title}</div>
          <Button onClick={handleFormatToBase64} hidden={isHidden}>
            转Base64
          </Button>
        </Space>
      }
      open={visible}
      onCancel={onCancel}
      footer={null}
      width={MODAL.WIDTH.LARGE}
    >
      <Input.TextArea
        value={str}
        readOnly
        autoSize={{
          minRows: MODAL.TEXT_AREA.MIN_ROWS,
          maxRows: MODAL.TEXT_AREA.MAX_ROWS,
        }}
      />
    </Modal>
  );
};

export default JsonModal;
